import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen w-full font-sans" data-id="element-0">
      <LandingPage data-id="element-1" />
    </div>;
}